<template>
  <div class="col-6 col-md filter-container auction-house-filter">
    <h4>{{ I18n.t('search_page.artworks_tab.filters.auction_house.title') }}</h4>
    <p>{{ I18n.t('search_page.artworks_tab.filters.auction_house.labels.name') }}:</p>
    <div class="input-cont">
      <input type="search" :value="auctionHouseQueryValue" @blur="changeAuctionHouseQuery($event)" @keyup.enter="loseFocus($event)">
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import { ARTWORKS_FILTERS } from '../../../consts';

  export default {
    name: 'AuctionHouseFilterColumn',
    data() {
      return {
        path: ARTWORKS_FILTERS.AUCTION_HOUSE.PATH,
      };
    },
    computed: {
      ...mapGetters(['filterValue']),
      auctionHouseQueryValue() {
        return this.filterValue(this.path);
      },
    },
    methods: {
      ...mapActions(['getArtworksWhenFilterIsChanging']),
      changeAuctionHouseQuery(event) {
        this.getArtworksWhenFilterIsChanging(
          { path: this.path, value: event.target.value },
        );
      },
      loseFocus(event) {
        event.target.blur(event);
      },
    },
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/search_page/index/components/artworks_tab/filters/auction_house_filter_column.vue?23548b94